// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1kICg","fullView":"styles_fullView__2fWOE"};